module.exports = __webpack_public_path__ + "static/media/main_features_person.d9a3df96.svg";